const ERROR = {
  SYSTEM_ERROR: "System error. Please try again later!",
};

const TODO_SORT_TYPE = {
  ATTENDANCE: 1,
  WORKING_HOURS: 2,
  FLAGS: 3,
  TASKS: 4,
};

const PAGINATION = {
  PAGE_SIZE: 1000,
  PAGE_NUM: 1,
  KANBAN_PAGE_SIZE: 2000,
  KANBAN_PAGE_NUM: 1,
};

const BOARD_TYPE = {
  BACKLOG: 1,
  DEVELOPMENT: 2,
  QUALITY_ASSURANCE: 3,
  COMPLETED: 4,
  TODO: 5,
};

const USER_ROLE_TYPE = {
  ADMIN: 1,
  EMPLOYEE: 2,
  EMPLOYEE_ADMIN: 3,
  ORGANIZATION_ADMIN: 4,
  CLIENT: 5,
};
const MANAGER_ROLE = [
  { id: 15, title: "Admin" },
  { id: 14, title: "Manager" },
  { id: 2, title: "Employee" },
];

const TODO_SORT_TYPE_OPTIONS = [
  { key: 1, value: "Attendance" },
  { key: 2, value: "Working Hours" },
  { key: 3, value: "Flags" },
  { key: 4, value: "Tasks" },
];
const FILE_TYPE = [
  { id: 0, title: "Music" },
  { id: 1, title: "Pictures" },
  { id: 2, title: "Videos" },
  { id: 3, title: "Documents" },
  { id: 4, title: "Zip" },
];
const STATUS_AND_TYPES = {
  CHECKINOUT: {
    CheckIn: 1,
    CheckOut: 2,
    Late: 7,
    OffBase: 9,
    InHouse: 8,
    Leave: 10,
    Absent: 11,
    ShortLeave: 12,
  },
  BREAK_TYPES: [
    {
      breakTypeId: 139,
      title: "Nimaz Break",
    },
    {
      breakTypeId: 140,
      title: "Lunch Break",
    },
    {
      breakTypeId: 141,
      title: "Refreshment Break",
    },
  ],
  PAYMENTSTATUS: [
    { id: 111, status: "PAID" },
    { id: 112, status: "PENDING" },
    { id: 113, status: "APPROVED" },
  ],
  INVOICESTATUS: [
    { id: 114, status: "PAID" },
    { id: 115, status: "PENDING" },
    { id: 116, status: "APPROVED" },
  ],
  PAYMENTTYPES: [
    { id: 117, type: "CASH" },
    { id: 118, type: "CHEQUE" },
    { id: 119, type: "BANK TRANSFER" },
    { id: 120, type: "OTHER" },
  ],
  RECURSIONTEAM: [
    { id: 121, type: "MONTHLY" },
    { id: 122, type: "QUARTERLY" },
    { id: 123, type: "YEARLY" },
    { id: 127, type: "WEEKLY" },
  ],
  INCOMESTATUS: [
    { id: 124, status: "PAID" },
    { id: 125, status: "PENDING" },
    { id: 126, status: "RELEASED" },
  ],
  LOANSTATUS: [
    { id: 127, status: "PAID" },
    { id: 128, status: "PENDING" },
  ],
  PROVIDENTFUNDSTATUS: [
    { id: 129, status: "PAID" },
    { id: 130, status: "PENDING" },
  ],
  PROVIDENTFUNDSTATUS: [
    { id: 131, status: "APPROVED" },
    { id: 132, status: "PENDING" },
  ],
  PROVIDENTFUNDTYPE: [
    { id: 133, type: "Fixed Amount" },
    { id: 134, type: "Percentage of Basic Salary" },
  ],
  LOANTYPE: [
    { id: 135, type: "I owe to others" },
    { id: 136, type: "Others owe to me" },
  ],
  ASSETSTATUS: [
    { id: 137, status: "Issued" },
    { id: 138, status: "Not-Issued" },
    { id: 139, status: "Returned" },
    { id: 172, status: "In-Use" },
  ],
  ASSET: [
    { id: 168, type: "Issued" },
    { id: 169, type: "Not Issued" },
    { id: 170, type: "Returned" },
    { id: 171, type: "In-Use" },
  ],
  ASSETSALLOCATIONSTATUS: [
    { id: 140, status: "In Use" },
    { id: 141, status: "Released" },
  ],
  DEGREETYPES: [
    { id: 142, type: "Undergraduate" },
    { id: 143, type: "Graduate" },
    { id: 144, type: "Post-Graduate" },
    { id: 145, type: "Matriculation" },
  ],
  SKILL_LEVEL: [
    { id: 146, level: "High" },
    { id: 147, level: "Medium" },
    { id: 148, level: "Low" },
  ],
  COMPANY_DEPT: [
    { id: 149, dept: "Accounts" },
    { id: 150, dept: "Development" },
    { id: 151, dept: "BD" },
    { id: 152, dept: "Agency" },
  ],
  DESIGNATION_TYPE: [
    { id: 249, dept: "Intern" },
    { id: 250, dept: "Jr. Developer" },
    { id: 251, dept: "Sr. Developer" },
    { id: 252, dept: "Project Manager" },
  ],
  JOBTYPE: [
    { id: 153, type: "Contractual" },
    { id: 154, type: "Permanent" },
  ],
  USERROLETYPE: [
    { id: 155, type: "Super Admin" },
    { id: 156, type: "Admin" },
    { id: 15, type: "Employee" },
  ],
  SUGGESTIONSTATUS: [
    { id: 160, type: "Done" },
    { id: 161, type: "Refuse" },
    { id: 162, type: "Pending" },
  ],
  EVENT_TYPES: [
    { id: 163, type: "Success" },
    { id: 164, type: "Info" },
    { id: 165, type: "Danger" },
    { id: 166, type: "Primamry" },
    { id: 167, type: "Warning" },
  ],

  PROJECT_STATUS: [
    { id: 47, type: "Off Track" },
    { id: 48, type: "On Track" },
    { id: 49, type: "On Hold" },
    { id: 50, type: "Critical" },
    { id: 54, type: "New" },
  ],
  CURRENCY_TYPES: [{ id: 53, type: "US Dollar" }],
  PROJECT_TEAMS: [
    { id: 4, title: "General" },
    { id: 7, title: "MemoreDev Team" },
    { id: 26, title: "MLD Team" },
    { id: 6, title: "Vision Collab" },
    { id: 27, title: "MediClinic Team" },
    { id: 28, title: "MediLink" },
  ],
  TASK_SEVERITY: [
    // { id: 0, type: "Severity" },
    { id: 1, type: "Critical" },
    { id: 2, type: "Important" },
    { id: 3, type: "Normal" },
    { id: 4, type: "Minor" },
    { id: 40, type: "Low" }, // it has PK-40 in lookups table
  ],
  TASK_TYPES: [
    // { id: 0, type: "Select Type" },
    { id: 35, type: "Task" },
    { id: 36, type: "Bug" },
    { id: 37, type: "Epic" },
  ],
  TASK_BOARD_TYPE: [
    // {id:0,type:"Status"},
    {
      id: 1,
      type: "BackLog",
    },
    {
      id: 2,
      type: "Development",
    },
    {
      id: 3,
      type: "Quality Assurance",
    },
    {
      id: 4,
      type: "Completed",
    },
    {
      id: 5,
      type: "ToDo",
    },
  ],
  LEAVES_STATUS: [
    { id: 146, status: "Approved" },
    { id: 147, status: "Rejected" },
    { id: 148, status: "Paid Approved" },
    { id: 149, status: "Unpaid Approved" },
    { id: 150, status: "Pending" },
  ],
  TODOLIST_TYPES: [
    { id: 62, type: "General" },
    { id: 76, type: "Management" },
  ],
  TODO_SEVERITY: {
    High: 44,
    Medium: 45,
    Low: 46,
  },
  BD_CLIENT_TYPE: [
    { id: 3, type: "Agency" },
    { id: 4, type: "Startup" },
    { id: 5, type: "Individual" },
    { id: 6, type: "Enterprise" },
    { id: 7, type: "B2B Agency" },
    { id: 8, type: "Upwork Plus" },
    { id: 9, type: "Other" },
  ],
  BD_PROJECT_STATUS: [
    { id: 3, status: "On Hold" },
    { id: 4, status: "Follow Up" },
  ],
  BD_PLATEFORMS: [
    { id: 3, plateform: "Upwork" },
    { id: 4, plateform: "LinkedIn" },
    { id: 5, plateform: "Social Media" },
    { id: 6, plateform: "Website" },
  ],
  BD_PROFILE: [
    { id: 1, profile: "Irfan Malik" },
    { id: 2, profile: "Ayaz Qaiser" },
    { id: 3, profile: "Dr. Tanzeen" },
  ],
};

const PROJECT_TEMPLATE = [
  {
    lookupId: 153,
    lookupTitle: "Design",
    lookupValue: "Design",
  },
  {
    lookupId: 154,
    lookupTitle: "HR & Operation",
    lookupValue: "HR & Operation",
  },
  {
    lookupId: 155,
    lookupTitle: "Project Managment",
    lookupValue: "Project Managment",
  },
  {
    lookupId: 156,
    lookupTitle: "Remote Work",
    lookupValue: "Remote Work",
  },
];
const TASK_CATEGORY = [
  {
    lookupId: 158,
    lookupTitle: "Development",
    lookupValue: "Development",
  },
  {
    lookupId: 159,
    lookupTitle: "Front-End Development",
    lookupValue: "FrontEndDevelopment",
  },
  {
    lookupId: 160,
    lookupTitle: "Back-End Development",
    lookupValue: "BackEndDevelopment",
  },
  {
    lookupId: 161,
    lookupTitle: "Management",
    lookupValue: "Management",
  },
];

const PATH = {
  NOPAGE: "*",
  HOMEPAGE: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard/:type",
  TEAMSCHEDULER: "/team-scheduler",
  SIDEBAR: "/sidebar",
  INCOME: "/income",
  INCOMETYPE: "/incometype",
  EXPENSE: "/expenses",
  EXPENSETYPE: "/expensetype",
  EMPLOYEE: "/employeelist",
  INVOICELIST: "/invoicelist",
  NEWINVOICE: "/newinvoice",
  SALARY: "/salary",
  ADDSALARY: "/salary/addSalary",
  FINANCE_DASHBOARD: "/finance-dashboard",
  PROVIDENT_FUND: "/provident-funds",
  LOANS: "/loans",
  CASHCATEGORY: "/cashcategory",
  ASSETS: "/assets",
  ASSETSALLOCATION: "/assets-allocation",
  ADDEMPLOYEE: "/add_employee",
  CLIENTS: "/client",
  DAILYATTENDANCE: "/daily-attendance",
  ATTENDANCE: "/attendance",
  LEAVEREQUEST: "/leave-request",
  LATECOMING: "/late-coming",
  USERLIST: "/users",
  DEPARTMENTS: "/departments",
  TEAMS: "/teams",
  PROJECTWITHTEMPLATE: "/project-template-selection",
  SUGGESTIONS: "/suggestions",
  HOLIDAYS: "/holidays",
  USER_ROLES: "/user-roles",
  TRASH: "/trash",
  FILES: "/files",
  PROJECTS: "/projects",
  ADDNEWPROJECT: "/add-new-project",
  PROJECTMILESTONE: "/:id/milestones",
  PROJECTSETTING: "/:projectId/settings",
  WORKLOAD: "/workload",
  MANAGEMENU: "/ManageMenu",
  VIDEOLINKS: "/VideoLinks",
  EVENT: "/event",
  KANBAN: "/Task/projectId/:id",
  MANAGEUSER: "/Manage-User",
  FILE_CATEGORY: "/file_category",
  ORGANIZATION: "/organization",
  TODO: "/ToDo",
  PROJECTSETTINGS: "/projectsettings",
  BILLABLEHOURS: "/billablehours",
  ROLEBASEDMENUS: "/rolebasedmenus",
  MYWORK: "/mywork",
  REPORTFILES: "/ReportFiles",
  NOTIFICATIONSETTINGS: "/notification-settings",
  NOTICEBOARD: "/Notice-Board",
  TEMPLATE: "/templates",
  FEEDBACKASSIGN: "/feedback/assign",
  FEEDBACKREVIEW: "/feedback/review",
  GIVEFEEDBACK: "/feedback/set",
  BDPROJECTDATA: "/BdProjectData",
  BDPROJECTAGENTALLOCATION: "/BdProjectAgentAllocation",
  PRICING: "/pricing",
  UPDATED_LAYOUT: "/updatedLayout",
  NEW_WORK_LOAD: "/new-workload",
  SIGN_UP: "/signUp",
  COMPLETEPROFILE: "/completeProfile",
  HOME: "/home",
  VIDEOCALL: "/videoCall",
  FORGOTTONPASSWORD: "/forgottonPassword",
  SETNEWPASSWORD: "/setNewpassword",
  LANDINGPAGE: "/landingPage",
  PROJECT_TEMPLATE: "/projectTemplates",
  PROFILE: "/profile",
  USERS_SUMMARY: "/report-users-summary",
  PROJECTS_SUMMARY: "/report-projects-summary",
};

// https://vcinternalapi.azurewebsites.net/api

//Pro
// const baseUrl = "https://vcdevapi.visioncollab.com/api";

//Stg
// const baseUrl = "https://stgvisioncollabapi.azurewebsites.net/api";
// const baseUrl = "https://pmsoldapi.visioncollab.com/api";

// const baseUrl = "https://greatblueboard50.conveyor.cloud/api";
const baseUrl = "https://pmsapidev.visioncollab.com/api";
const localhostBaseUrl = "http://localhost:58934/api";
// const baseUrl = "https://pms-be.xeventechnologies.com/api";

// const baseUrl = "https://earlygreenapple81.conveyor.cloud/api";

// const baseUrl = "https://pmsapi.visioncollab.com/api";
// const baseUrl = "https://foundbluedog8.conveyor.cloud/api";
const baseUrlMongoDB = "https://covismongolive.covis.ai";

//Local Conveyer
// const baseUrl = "http://192.168.10.71:45455/api";

const APP_SETTINGS = {
  API_PATH: {
    ATTENDANCE: {
      todayAttendanceSummary: baseUrl + "/Attendance/TodayAttendanceSummary",
      attendanceSummary: baseUrl + "/Attendance/AttendanceSummary",
      attendanceReport: baseUrl + "/Attendance/AttendanceReport",
      lateCheckIn: baseUrl + "/EmpAttendance/LateCheckIn",
      markAttendance: baseUrl + "/Attendance/MarkAttendance",
      checkout: baseUrl + "/Attendance/Checkout",
      leaveRequest: baseUrl + "/Attendance/LeaveRequest",
      shortBreak: baseUrl + "/Attendance/ShortBreak",
      leaveRequests: baseUrl + "/Attendance/LeaveRequests",
      leaveRequests: baseUrl + "/Attendance/LeaveRequests",
      leaveApproval: baseUrl + "/Attendance/ApproveLeave",
      dailyAttendanceList: baseUrl + "/Attendance/DailyAttendanceList",

      // markAttendance: baseUrl + "/Attendance/MarkAttendance",
      checkout: baseUrl + "/Attendance/Checkout",
      employeeCheckInOrOut: baseUrl + "/EmpAttendance/EmployeeCheckInOrOut",
      shortLeaveRequest: baseUrl + "/Attendance/ShortLeave",
      getEmployeeTodayAttendance: baseUrl + "/Attendance/CheckAttendanceStatus",
      getLeaveRequest: baseUrl + "/EmpAttendance/GetAllLeaveRequest",
      approveLeaveRequest: baseUrl + "/EmpAttendance/Approve",
      getEmployeesAttendance: baseUrl + "/Attendance/GetEmployeeAttendanceList",
      endBreak: baseUrl + "/EmpAttendance/EndBreak",
      getBreakTypes: baseUrl + "/EmpAttendance/GetBreakTypes",
      getAttendanceReportByAdmin:
        baseUrl + "/Attendance/AttendanceReportByAdmin",
    },
    //Assets
    ASSETS: {
      getAssetList: baseUrl + "/",
      addNewAsset: baseUrl + "/",
      removeAsset: baseUrl + "/",
      //Asset Types
      ASSETTYPES: {
        getAssetType: baseUrl + "/",
        addAssetType: baseUrl + "/",
        deleteAssetType: baseUrl + "/",
      },
    },

    //Assets Allocation
    ASSETSALLOCATION: {
      getAllocatedAssets: baseUrl + "/",
      addNewAllocatedAsset: baseUrl + "/",
      removeAllocatedAsset: baseUrl + "/",
    },
    //Client
    CLIENT: {
      getClientList: baseUrl + "/Client/GetClientList",
      addNewClient: baseUrl + "/Client/CreateClient",
      deleteClient: baseUrl + "/Client/DeleteClient",
      updateClient: baseUrl + "/Client/UpdateClient",
    },
    //Daily Attendance
    DAILY_ATTENDANCE: {
      getDailyAttendanceReport:
        baseUrl + "/Attendance/GetEmployeeAttendanceList",
    },
    //Employees
    EMPLOYEE: {
      getEmployeeForSalary: baseUrl + "/Salary/EmployeeListForSalary",
      blockOrUnblockEmployee: baseUrl + "/",
    },
    //Expense
    EXPENSE: {
      addExpense: baseUrl + "/Expense/AddExpense",
      addExpenseList: baseUrl + "/Expense/AddExpenseList",
      getExpense: baseUrl + "/Expense/GetAllExpenses",
      removeExpense: baseUrl + "/Expense/DeleteExpense",
      //Expense Type
      EXPENSETYPE: {
        getExpenseTypes: baseUrl + "/ExpenseType/GetAllExpenseTypes",
        addExpenseType: baseUrl + "/ExpenseType/AddEditExpenseType",
        deleteExpenseType: baseUrl + "/ExpenseType/DeleteExpense",
      },
      // Sub-Expense Type
      SUBEXPENSES: {
        getSubExpenses: baseUrl + "/ExpenseType/GetAllSubExpenseTypes",
        addSubExpense: baseUrl + "/ExpenseType/AddEditSubExpenseType",
        deleteSubExpense: baseUrl + "/ExpenseType/DeleteSubExpense",
      },
    },
    //Finance Dashboard
    FINANCE_DASHBOARD: {
      incomeExpenseData: baseUrl + "/Dashboard/GetIncomExpenseDashboardData",
      incomeExpenseTypeWise: baseUrl + "/Dashboard/GetExpenseTypeWiseAnalysis",
      projectBudgetLead: baseUrl + "/Dashboard/GetProjectBudgetByLeads",
      monthlyExpense: baseUrl + "/Dashboard/ExpensePieData",
      yearlyIncomeExpense: baseUrl + "/Dashboard/IncomeVsExpenseByYear",
    },
    //Income
    INCOME: {
      getIncomeList: baseUrl + "/Income/GetAllIncome",
      addNewIncome: baseUrl + "/Income/AddIncome",
      deleteIncome: baseUrl + "/Income/DeleteIncome",
      getAllProjects: baseUrl + "/Income/getAllProjects",
      // Income Type
      INCOMETYPE: {
        getIncomeTypes: baseUrl + "/IncomeType/GetAllIncomeTypes",
        addIncomeType: baseUrl + "/IncomeType/AddEditIncomeType",
        deleteIncomeType: baseUrl + "/IncomeType/DeleteIncome",
      },
    },
    //Invoice
    INVOICE: {
      getInvoice: baseUrl + "/",
      addInvoice: baseUrl + "/",
      removeInvoice: baseUrl + "/",
    },
    //Late Coming
    LATECOMING: {
      getLateComingList: baseUrl + "/EmpAttendance/GetLateComersByFilter",
    },
    //Leaves
    LEAVES: {
      updateLeaveRequestStatus: baseUrl + "/EmpAttendance/Approve",
      LEAVESTYPE: {
        getAllLeavesType: baseUrl + "/LeaveType/GetAllLeaveTypes",
      },
    },
    // Loans
    LOANS: {
      getLoansOwnToOthers: baseUrl + "/",
      getLoansOwnToMe: baseUrl + "/",
      addNewLoan: baseUrl + "/",
      deleteLoan: baseUrl + "/",
    },
    //Login
    LOGIN: {
      login: baseUrl + "/Login/AuthUser",
      loginCovisTour: baseUrl + "/Login/IsCovisTour",
    },
    //SIGN UP
    SIGNUP: {
      singUp: baseUrl + "/Account/SignUp",
      AccountExist: baseUrl + "/Account/AccountExist",
      ResendOTP: baseUrl + "/Account/ResendOTP",
      ConfirmOTP: baseUrl + "/Account/ConfirmOTP",
      CompleteProfile: baseUrl + "/Account/CompleteProfile",
    },
    ZOOM: {
      getAllMeetings: baseUrlMongoDB + "/zoom-api/get-all-meetings",
      instantMeeting: baseUrlMongoDB + "/zoom-api/instant-meeting",
      scheduleMeeting: baseUrlMongoDB + "/zoom-api/schedule-meeting",
      updateScheduleMeeting:
        baseUrlMongoDB + "/zoom-api/schedule-meeting/:meetingId",
      zoomOAuth: baseUrlMongoDB + "/zoom-api/zoom-oauth",
      meetingSingleRecord: baseUrlMongoDB + "/zoom-api/get-meeting",
    },
    //Payment Methods
    PAYMENTMETHOD: {
      getAllPaymentMethods: baseUrl + "/PaymentMethods/GetAllPaymentMethods",
      addPaymentMethod: baseUrl + "/PaymentMethods/AddEditPaymentMethod",
      deletePaymentMethod: baseUrl + "/PaymentMethods/DeletePaymentMethod",
    },
    // Project
    PROJECTS: {
      getEmployeeTasksByProject:
        baseUrl +
        "/Project/GetEmployeeTasksByProject/getEmployeeTasksByProject",

      // https://pmsapidev.visioncollab.com/api/Project/GetEmployeeTasksByProject/getEmployeeTasksByProject
      getProjectsByEmployee:
        baseUrl + "/Project/GetProjectsByEmployee/getProjectsByEmployee",
      getProjects: baseUrl + "/Project/GetProjectByFilter",
      getProjectById: baseUrl + "/Project/GetProjectByProjectId",
      getProjectInfo: baseUrl + "/Project/GetAllClientAndProjectCategory",
      getProjectsByAllFilter: baseUrl + "/Project/GetProjectsByAllFilter",
      addEditProject: baseUrl + "/Project/SaveProject",
      deleteProject: baseUrl + "/Project/DeleteProject",
      getProjectSelectListByRole:
        baseUrl + "/Project/GetProjectSelectListByRole",
      PROJECTBACKLOG: {
        addProjectBackLogTasks:
          baseUrl + "/ProjectBacklog/CreateProjectBacklogTasks",
        getProjectBackLogTasks:
          baseUrl + "/ProjectBacklog/GetProjectBacklogTasksDetailsByProjectId",
        addBackLogTasksInMilestone:
          baseUrl + "/ProjectMileStone/AddTaskInMilestone",
        deleteProjectBackLogTask:
          baseUrl + "/ProjectBacklog/DeleteProjectBacklogTask",
        moveToSprint: baseUrl + "/ProjectBacklog/MoveBacklockTaskToSprintTask",
      },
      PROJECTCATEGORY: {
        getProjectCategory: baseUrl + "/ProjectCategory/GetAllByUser",
      },
      PROJECTMILESTONE: {
        getMilestonesByProject: baseUrl + "/ProjectMileStone/FilterMileStones",
        kanbanFilterTaskByProject:
          baseUrl +
          "/Project/GetProjectFilterProject/GetProjectFilterProjectId",
        GetMilestoneSelectList:
          baseUrl + "/ProjectMileStone/GetMilestoneSelectList",
        //getMilestonesByProject: baseUrl + "/ProjectMileStone/FilterMileStones",
        deleteMilestone: baseUrl + "/ProjectMileStone/DeleteMilestone",
        addProjectMilestone: baseUrl + "/ProjectMileStone/CreateMileStone",
        createTaskInMilestone:
          baseUrl + "/ProjectMileStone/CreateMilestoneTask",
        fetchTaskInMilestone:
          baseUrl + "/ProjectMileStone/FilterMileStoneTasks",
        getCommentOfTaskInMilestone: baseUrl + "/ProjectMileStone/getComments",
        postCommentOfTaskInMilestone: baseUrl + "/ProjectMileStone/Comment",
        deleteCommentOfTaskInMilestone:
          baseUrl + "/ProjectMileStone/DeleteComment",
        changeTaskMilestone: baseUrl + "/ProjectMileStone/ChangeTaskMilestone",
        changeReleaseStatus: baseUrl + "/ProjectMileStone/ChangeReleaseStatus",
        filterMileStones: baseUrl + "/ProjectMileStone/FilterMileStones",
        startSprint: baseUrl + "/ProjectMileStone/StartMileStone",
        completeSprintIfTasksCompleted:
          baseUrl + "/ProjectMileStone/CompleteMilesStoneIfTaskCompleted",
        getAllSprintsWithoutStartSprint:
          baseUrl + "/ProjectMileStone/GetAllMilesStoneWithOutStartMileStone",
        moveSprintTasks: baseUrl + "/ProjectMileStone/MoveSprintTasks",
        userSelectedMileStone:
          baseUrl + "/ProjectMileStone/UserSelectedMileStone",
      },
    },
    // Project Templates
    PROJECT_TEMPLATES: {
      GetProjectTemplateCategoryListById:
        baseUrl + "/ProjectTemplateCategory/GetProjectTemplateCategoryListById",
      GetProjectTemplateBoardDetailsById:
        baseUrl + "/ProjectTemplateCategory/GetProjectTemplateBoardDetailsById",
    },
    // Provident Fund
    PROVIDENT_FUND: {
      getFundList: baseUrl + "/",
      addNewFund: baseUrl + "/",
      deleteFund: baseUrl + "/",
    },
    //Salary
    SALARY: {
      getAllSalaryList: baseUrl + "/",
    },
    //Scheduler
    SCHEDULER: {
      getSchedulerList: baseUrl + "/TeamSchadule/GetTeamSchadules",
      deleteSchedulerEvent: baseUrl + "/",
      addSchedulerEvent: baseUrl + "/TeamSchadule/AddEditTeamSchadule",
      getProjectLookup: baseUrl + "/teamScheduler/getProjectLookup",
      getUserLookup: baseUrl + "/teamScheduler/getUserLookup",
      getDepartmentLookup: baseUrl + "/teamScheduler/getDepartmentLookup",
      getTeamLookup: baseUrl + "/teamScheduler/getTeamLookup",
      getUsers: baseUrl + "/teamScheduler/getUsers",
      getProjects: baseUrl + "/teamScheduler/getProjects",
      getTasks: baseUrl + "/teamScheduler/getTasks",
      getUserProjectsTask: baseUrl + "/teamScheduler/getUserProjectsTask",
      updateTaskDueDate: baseUrl + "/ProjectTask/UpdateTaskDueDate",
      getProjectUsersTask: baseUrl + "/teamScheduler/getProjectUsersTask",
      getTaskDetails: baseUrl + "/teamScheduler/getTaskDetails",
    },
    //Tasks
    TASK: {
      UpdateBulkTaskData: baseUrl + "/ProjectTask/UpdateBulkTaskData",
      getWorkingHours: baseUrl + "/Users/GetWorkingHours",

      getProjectTaskList:
        baseUrl + "/ProjectTask/GetProjectTasksDetailsByProjectId",
      getProjectTaskDetail: baseUrl + "/ProjectTask/GetProjectTaskDetail",
      getNextProjectTaskList: baseUrl + "/ProjectTask/GetProjectTaskByBoardId",
      addProjectTask: baseUrl + "/ProjectTask/CreateProjectTask",
      removeTask: baseUrl + "/ProjectTask/RemoveTaskById",
      removeBoard: baseUrl + "/TaskBoard/DeleteById",
      editTask: baseUrl + "/ProjectTask/UpdateProjectTask",
      deleteAttachment: baseUrl + "/ProjectTask/DeleteAttachment",
      getTaskboardStatuses: baseUrl + "/TaskBoardStatus/GetAll",
      createTaskBoard: baseUrl + "/TaskBoard/Save",
      changeTaskStatus: baseUrl + "/ProjectTask/ChangeStatus",
      invite: baseUrl + "/Project/SendProjectInvitation",
      removeEmployee: baseUrl + "/Project/RemoveUserFromProject",
      fetchQaTemplates: baseUrl + "/QAProtocolTemplate/GetTemplates",
      addQaTemplate: baseUrl + "/QAProtocolTemplate/AddTemplate",
      removeQaTemplate:
        baseUrl + "/QAProtocolTemplate/DeleteTemplate?QAProtocolTemplateId=",
      getUsersDataForInviteInProject:
        baseUrl + "/Users/getUsersDataForInviteInProject",
      getCommentOfTaskInKanban: baseUrl + "/Tasks/getComments",
      postCommentOfTaskInKanban: baseUrl + "/Tasks/Comment",
      deleteCommentOfTaskInKanban: baseUrl + "/Tasks/DeleteComment",
      getTaskHistory: baseUrl + "/Tasks/GetTaskHistoryV3",
      getTaskWorkLog: baseUrl + "/Tasks/GetTaskWorkLog",
      postTaskWorkLog: baseUrl + "/Tasks/TaskWorkLog",
    },
    TASK_BOARD: {
      updateTaskBoardsOrder:
        baseUrl + "/TaskBoard/UpdateTaskBoardsOrder/updateTaskBoardsOrder",
      getAllBoardsByProject: baseUrl + "/TaskBoard/GetAllBoardsByProject",
    },
    // Departments
    DEPARTMENTS: {
      getAllDepartments: baseUrl + "/Department/GetDepartmentsList",
      getDepartmentsSelectList:
        baseUrl + "/Department/GetDepartmentsSelectList",
      saveDepartment: baseUrl + "/Department/Save",
      deleteDepartment: baseUrl + "/Department/Delete",
    },
    //Department task category
    DEPARTMENT_TASK_CATEGORIES: {
      getCategories: baseUrl + "/DepartmentTaskCategory/GetTaskCategories",
      saveCategory: baseUrl + "/DepartmentTaskCategory/Save",
      deleteCategory: baseUrl + "/DepartmentTaskCategory/Delete",
      getCategoriesSelectList:
        baseUrl + "/DepartmentTaskCategory/GetCategoriesSelectList",
    },
    //Users
    USERS: {
      getUsers: baseUrl + "/User/GetUsers",
      getTeamLeads: baseUrl + "/Users/getTeamLeads",
      getTeamMembers: baseUrl + "/Users/GetTeamMembers",
      getEmployeesSelectList: baseUrl + "/Users/GetEmployeesSelectList",
      getAllUserList: baseUrl + "",
      getEmployeesList: baseUrl + "/Users/GetEmployeesList",
      updateUserDepartment: baseUrl + "/Users/UpdateUserDepartment",
      getEmployeesSelectListByRole:
        baseUrl + "/Users/GetEmployeesSelectListByRole",
    },
    // Team Scheduler
    TEAM_SCHEDULER_URL: {
      teamSchedulerList: baseUrl + "/TeamScheduler/GetAllTeamScheduler",
    },
    // Teams
    TEAMS: {
      getAllTeams: baseUrl + "/",
      addNewTeam: baseUrl + "/",
      editTeam: baseUrl + "/",
      deleteTeam: baseUrl + "/",
    },
    // Suggestions
    SUGGESTIONS: {
      getSuggestions: baseUrl + "/",
      addSuggestion: baseUrl + "/",
    },
    // Holidays
    HOLIDAYS: {
      getHolidays: baseUrl + "/",
    },
    USER_ROLES: {
      getAllUserRoles: baseUrl + "/",
      addUserRole: baseUrl + "/",
      editUserRole: baseUrl + "/",
      removeUserRole: baseUrl + "/",
    },
    // Project Settings
    PROJECTSETTINGS: {
      getProjectTeams: baseUrl + "/",
      addProjectTeams: baseUrl + "/",
      deleteProjectTeams: baseUrl + "/",
      editProjectTeams: baseUrl + "/",
      getCategory: baseUrl + "/",
      addCategory: baseUrl + "/",
      deleteCategory: baseUrl + "/",
      editCategory: baseUrl + "/",
    },
    // Todo
    TODO: {
      getToDoEmployees: baseUrl + "/ToDo/GetToDo_Employees",
      getEmployeeTodos: baseUrl + "/ToDo/GetEmployee_Todos",
      getToDo: baseUrl + "/ToDo/GetToDosByFilters_paginated",
      addToDo: baseUrl + "/ToDo/CreateToDo",
      deleteToDo: baseUrl + "/ToDo/DeleteToDo",
      editToDo: baseUrl + "/ToDo/UpdateToDo",
      completeToDo: baseUrl + "/ToDo/CompleteToDo",
      todoComment: baseUrl + "/ToDo/Comment",
      getTodoComments: baseUrl + "/ToDo/getComments",
      todoDeleteComment: baseUrl + "/ToDo/DeleteComment",
      getWorkProgress: baseUrl + "/ToDo/GetWorkProgress",
      todoFlag: baseUrl + "/ToDoFlag/SaveToDoFlag",
      taskCategories: baseUrl + "/DepartmentTaskCategory/SaveToDoFlag",
      getLoggedHourGraph: baseUrl + "/ToDo/GetLoggedHoursGraph",
      getTaskHourComparisonByEmployee:
        baseUrl + "/ToDo/GetTaskHoursComparisonByEmployee",
      getEmployeeRankingOnLoggedHours:
        baseUrl + "/ToDo/GetEmployeeRankingOnLoggedHours",
      getEmpTasksGraph: baseUrl + "/ToDo/GetEmployeeTasksGraph",
      getAllUserToDo: baseUrl + "/ToDo/GetAllUserToDo",
      getEmpTodoTaskList: baseUrl + "/WorkLoad/GetToDoTaskList",
      getUserToDos: baseUrl + "/ToDo/GetUserToDosByDateRange",
    },
    TODO_LIST: {
      getAllUserToDo: baseUrl + "/ToDoList/GetAllUserToDo",
      CreateToDoList: baseUrl + "/ToDoList/CreateToDoList",
    },
    //Feedback
    FEEDBACK: {
      getTemplates: baseUrl + "/FeedbackTemplate/getAll",
      addTemplate: baseUrl + "/FeedbackTemplate/addUpdate",
      deleteTemplate: baseUrl + "/FeedbackTemplate/DeleteById?Id=",
      getQuestions: baseUrl + "/FeedbackQuestion/getAllByTemplateType?Id=",
      addQuestion: baseUrl + "/FeedbackQuestion/addUpdate",
      deleteQuestion: baseUrl + "/FeedbackQuestion/DeleteById?Id=",

      feedbackReviews: baseUrl + "/FeedbackReview/getAll",

      AddEvaluation: baseUrl + "/FeedbackEvaluation/addUpdate",
      getAllEvaluation: baseUrl + "/FeedbackEvaluation/getAll",

      giveFeedback: baseUrl + "/FeedbackReview/getGiveFeedBack?UserId=",
      addAnswers: baseUrl + "/FeedbackAnswer/addUpdateAnswers",
      getAnswersByEvaluationId: baseUrl + "/FeedbackAnswer/getAllByEvaluation",
      completeStatus: baseUrl + "/FeedbackEvaluation/updateStatus",

      // Evaluation filtered api
      evaluationFiltered: baseUrl + "/FeedbackEvaluation/getFiltered",
    },
    BD_PROJECT_DATA: {
      getCountries: baseUrl + "/BDProject/GetCountries",
      getWarmLeads: baseUrl + "/BDProject/GetWarmLeads",
      getLeadsPerPlatform: baseUrl + "/BDProject/GetLeadPerPlatform",
      getBusinessPerAgent: baseUrl + "/BDProject/GetBusinessPerAgent",
      leadsGeneratedPerAgent: baseUrl + "/BDProject/LeadsGeneratedPerAgent",
      conversionPerAgent: baseUrl + "/BDProject/ConversionPerAgent",
      conversionTrend: baseUrl + "/BDProject/ConversionTrend",
      getQuarterlyData: baseUrl + "/BDProject/GetQuarterlyData",
      getWarmLeadsList: baseUrl + "/BDProject/GetWarmLeadsList",

      getStates: baseUrl + "/BDProject/GetStates",
      getCities: baseUrl + "/BDProject/GetCities",
      getProjectCategory: baseUrl + "/BDProject/GetProjectCategories",
      getKeywords: baseUrl + "/BDProject/GetKeywords",
      getTechKeywords: baseUrl + "/BDProject/GetTechKeywords",
      getProjectsData: baseUrl + "/BDProject/GetProjectsData",
      getProjectData: baseUrl + "/BDProject/GetProjectData",
      saveProjectData: baseUrl + "/BDProject/Save",
      deleteProjectData: baseUrl + "/BDProject/Delete",
      checkProjectEmail: baseUrl + "/BDProject/IsValidEmail",
      checkProjectPostURL: baseUrl + "/BDProject/IsUniquePostURL",
      verifyProjectPhoneNumber: baseUrl + "/BDProject/VerifyPhone",
      saveProjectAgentAllocation:
        baseUrl + "/BdProjectAgentTimeAllocation/Save",
      deleteProjectAgentAllocation:
        baseUrl + "/BdProjectAgentTimeAllocation/Delete",
      getProjectAgentAllocation:
        baseUrl + "/BdProjectAgentTimeAllocation/GetAgentTimeAllocation",
      getProjectAgentAllocationList:
        baseUrl + "/BdProjectAgentTimeAllocation/GetAgentTimeAllocationList",
    },
    FILES: {
      getFolderList: baseUrl + "/Files/GetFolderList",
      addFolderList: baseUrl + "/Files/CreateFolders",
      deleteFolder: baseUrl + "/Files/DeleteFolder",
      getDeletedFolderList: baseUrl + "/Files/GetDeletedForlderList",
      getRecentFolderList: baseUrl + "/Files/GetRecentFolderList",
      getFavoriteFolderList: baseUrl + "/Files/GetFavoriteFolderList",
      addAndRemoveFromMyFavFolder:
        baseUrl + "/Files/AddAndRemoveFromMyFavFolder",
      addToFavoriteFolder: baseUrl + "/Files/AddToFavoriteFolder",
      removeFromFavoriteFolder: baseUrl + "/Files/RemoveFromFavoriteFolder",
      getFileList: baseUrl + "/Files/GetAllFiles",
      addFileList: baseUrl + "/Files/CreateFile",
      getRecentFilesList: baseUrl + "/Files/GetRecentFileList",
      getFavoriteFileList: baseUrl + "/Files/GetFavFileList",
      addAndRemoveFromMyFavFile: baseUrl + "/Files/AddAndRemoveFromMyFavFile",
      deleteFile: baseUrl + "/Files/DeleteFile",
      getDeletedFileList: baseUrl + "/Files/GetDeleteFileList",
    },
    ORGANIZATION: {
      getAllOrganiazations: baseUrl + "/Organization/GetAll",
      craeteOrganization: baseUrl + "/Organization/CreateOrganization",
      editOrganization: baseUrl + "/Organization/UpdateOrganization",
      activeOrganization: baseUrl + "/Organization/ActiveOrgainizationById",
      deleteOrganization: baseUrl + "/Organization/DeleteOrganization",
      setUserOrganization: baseUrl + "/Organization/SelectOrganization",
    },
    MANAGE_USER: {
      createManageUser: baseUrl + "/ManageUser/CreateUser",
      getAllManageUser: baseUrl + "/ManageUser/GetAllUsers",
      editManageUser: baseUrl + "/ManageUser/UpdateUser",
      deleteManageUser: baseUrl + "/ManageUser/DeleteUser",
      changeUserStatus: baseUrl + "/ManageUser/ActiveUser",
    },

    AZURE: {
      Azure: baseUrl + "/Azure/post",
    },
    DIGITAL_OCEAN: {
      digitalOcean: baseUrl + "/digitalOcean/post",
    },
    ATTACHMENTS: {
      uploadfile: baseUrl + "/Attachments/uploadFile",
    },
    WORKLOAD: {
      getSideBar: baseUrl + "/WorkLoad/GetEmployeesAndProjects",
      getEmpWorkload: baseUrl + "/WorkLoad/GeEmpWorkLoad",
      getEmployeeList: baseUrl + "/WorkLoad/GetEmployeeList",
      getProjectList: baseUrl + "/WorkLoad/GetProjectList",
      getTaskList: baseUrl + "/WorkLoad/GetTaskList",
      getTaskDetailsByUserId: baseUrl + "/WorkLoad/GetTaskDetailsByUserId",
      getEmployeeWorkLoadByUserId:
        baseUrl + "/WorkLoad/GetEmployeeWorkLoadByUserId",
      getEmployeeListByProjectId:
        baseUrl + "/WorkLoad/GetEmployeeListByProjectId",
    },
    QA_PROTOCOL: {
      createQaProtocol: baseUrlMongoDB + "/QA-protocol",
      editQaProtocol: baseUrlMongoDB + "/QA-protocol",
      getAllQaProtocol: baseUrlMongoDB + "/QA-protocol/all",
      qaProtocolReport: baseUrlMongoDB + "/QA-protocol",
      deleteProtocol: baseUrlMongoDB + "/QA-protocol",
    },
    SPRINTS: {
      getAllSprints: baseUrl + "/Organization/GetAll",
      craeteSprint: baseUrl + "/Sprint/CreateSprint",
      editSprint: baseUrl + "/Sprint/UpdateSprint",
      activeSprint: baseUrl + "/Sprint/ActiveOrgainizationById",
      deleteSprint: baseUrl + "/Sprint/DeleteSprint",
    },
    STICKY_NOTES: {
      createStickyNote: baseUrlMongoDB + "/sticky-notes",
      editStickyNote: baseUrlMongoDB + "/sticky-notes",
      getAllStickyNotes: baseUrlMongoDB + "/sticky-notes/all",
      deleteStickyNote: baseUrlMongoDB + "/sticky-notes",
    },
    SETTING_TRASH: {
      getDeleteList:
        baseUrlMongoDB + "/Project/GetDeletedProjectList/GetDeletedProjectList",
      restoreDeleteProject:
        baseUrlMongoDB + "/Project/RestoreProject/RestoreProject",
      emptyTrash: baseUrlMongoDB + "/Project/EmptyTrash/EmptyTrash",
      deleteTrashProject:
        baseUrlMongoDB +
        "/Project/DeleteProjectFromTrash/DeleteProjectFromTrash",
    },
    REPORT: {
      getMonthlySummaryProjectsReport:
        baseUrl + "/Reports/GetMonthlySummaryProjectsReport",
      getMonthlySummaryUsersReport:
        baseUrl + "/Reports/GetMonthlySummaryUsersReport",
    },
  },
  PAGE_SIZE: "20",
  DAILY_ATTENDANCE_PAGE_SIZE: "10",
};

export {
  PROJECT_TEMPLATE,
  ERROR,
  PAGINATION,
  STATUS_AND_TYPES,
  PATH,
  BOARD_TYPE,
  USER_ROLE_TYPE,
  APP_SETTINGS,
  TODO_SORT_TYPE,
  TODO_SORT_TYPE_OPTIONS,
  FILE_TYPE,
  MANAGER_ROLE,
  TASK_CATEGORY,
};
